import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Radio.module.scss';

const RadioButton = ({
  id,
  className,
  label,
  checked,
  disabled,
  children,
  ...rest
}) => (
  <label
    htmlFor={id}
    className={classnames(
      styles.radioButton,
      {
        [styles.checked]: checked,
        [styles.disabled]: disabled
      },
      className
    )}
  >
    <input
      id={id}
      type="radio"
      checked={checked}
      disabled={disabled}
      {...rest}
    />
    {label || children}
  </label>
);

RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func
};

RadioButton.defaultProps = {
  id: null,
  name: null,
  children: null,
  className: '',
  value: '',
  label: '',
  disabled: false,
  checked: false,
  onChange: null
};

export { RadioButton };
